<template>
  <div class="header-wrapper">
    <section class="main-header-grid">
      <p class="project-title">{{ project.project_name }}</p>
      <div v-if="!has_many" class="project-country item">
        <div class="img-wrapper">
          <!-- <img :src="project.project_country.flag_url" /> -->
          <img style="width: 16px" :src="$globe" alt="" />
        </div>
        <div class="text-wrapper">
          <span class="title">Country</span>
          <span>{{ project.project_country.name }}</span>
        </div>
      </div>

      <div class="project-type item">
        <div class="img-wrapper">
          <!-- <img :src="project.project_type.icon" /> -->
          <img style="width: 12px" :src="$waterIcon" />
        </div>
        <div class="text-wrapper">
          <span class="title"
            >Project Type{{
              project.project_type?.moreThenOne ? "'s" : ''
            }}</span
          >
          <span>{{ project.project_type.name }}</span>
        </div>
      </div>

      <div v-if="project.population" class="people-impacted item">
        <div class="img-wrapper">
          <!-- <img :src="$peopleIcon" /> -->
          <img style="width: 16px" :src="$peopleToImpact" />
        </div>
        <div class="text-wrapper">
          <span class="title">{{
            completed ? 'People Impacted' : 'Population'
          }}</span>
          <span>{{ project.population.toLocaleString('en') }}</span>
        </div>
      </div>

      <div v-if="project.completion_date" class="project-completed item">
        <div class="img-wrapper">
          <img :src="$calendarIcon" />
        </div>
        <div class="text-wrapper">
          <span class="title">Completed</span>
          <span>{{ getFormmatedData(project.completion_date) }}</span>
        </div>
      </div>

      <div
        v-if="
          Array.isArray(project.donors)
            ? project.donors.length > 0
            : project.donors
        "
        class="project-donor item"
      >
        <div class="img-wrapper">
          <img :src="$starDonorIcon" />
        </div>
        <div class="text-wrapper">
          <span class="title">Donor</span>
          <span v-if="Array.isArray(project.donors)">
            <span v-for="donor in project.donors" :key="donor.id">
              {{ donor.name }}
            </span>
          </span>
          <span v-else>
            {{ project.donors }}
          </span>
        </div>
      </div>

      <div
        v-if="!completed && project?.project_type?.cost >= 0 && false"
        class="project-cost item"
      >
        <div class="img-wrapper">
          <!-- <img style="width: 20px" :src="$dollarIcon" /> -->
          <img style="width: 16px" :src="$newDollarIcon" />
        </div>
        <div class="text-wrapper">
          <span class="title">Cost</span>
          <span>{{ project.project_type.cost.toLocaleString('en-IN') }}</span>
        </div>
      </div>

      <div
        v-if="completed && project?.project_type?.timeframe"
        class="project-timeframe item"
      >
        <div class="img-wrapper">
          <img :src="$calendarIcon" />
        </div>
        <div class="text-wrapper">
          <span class="title">Time Frame</span>
          <span>{{ project.project_type.timeframe }}</span>
        </div>
      </div>

      <div
        v-if="project?.location?.lat && project?.location?.lng"
        class="project-location item"
      >
        <div class="img-wrapper">
          <!-- <img :src="$mapOffIcon" /> -->
          <img style="width: 12px" :src="$locationIcon" />
        </div>
        <div class="text-wrapper">
          <span class="title">Location</span>
          <a class="popup-link" @click="showMapPopup = true">Open Map</a>
        </div>
      </div>

      <div
        v-if="showAnalytics && project.monitored"
        class="project-analytics item"
      >
        <div class="img-wrapper">
          <img :src="$dashboardOff" />
        </div>
        <div class="text-wrapper">
          <span class="title">Live Monitoring</span>
          <a
            class="popup-link"
            @click=";(showMonitoringPopup = true), loadData()"
          >
            Open Monitor
          </a>
        </div>
      </div>
    </section>
    <long-text
      v-if="project.description"
      :text="project.description"
    ></long-text>
  </div>
  <map-popup
    v-if="showMapPopup"
    @closePopup="showMapPopup = false"
    :center="{ lat: project.location.lat, lng: project.location.lng }"
    :projectType="project.project_type"
    :projectName="project.project_name"
    :projectCountry="project.project_country.name"
    :changePopUpStyle="changePopUpStyle"
  />

  <monitor-popup
    v-if="showMonitoringPopup"
    @closePopup="showMonitoringPopup = false"
    :data="dataForChart"
    :projectType="project.project_type.name"
    :projectName="project.project_name"
    :projectCountry="project.project_country.name"
    :changePopUpStyle="changePopUpStyle"
  />

  <div
    class="popup-open"
    v-if="showMapPopup"
    @click="showMapPopup = false"
  ></div>
  <div
    class="popup-open"
    v-if="showMonitoringPopup"
    @click="showMonitoringPopup = false"
  ></div>
</template>

<script>
import moment from 'moment'
import longText from './LongText.vue'
import mapPopup from './MapPopup.vue'
import monitorPopup from './MonitorPop.vue'
import axios from 'axios'
export default {
  props: {
    project: Object,
    showAnalytics: Boolean,
    has_many: Boolean,
    completed: Boolean,
    changePopUpStyle: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  components: {
    longText,
    mapPopup,
    monitorPopup,
  },
  data() {
    return {
      showMapPopup: false,
      showMonitoringPopup: false,
      dataForChart: null,
      emptyChart: {
        config: analyticsConfig,
        data: {
          labels: [],
          datasets: [],
        },
      },
    }
  },
  created() {
    this.config = analyticsConfig
  },
  methods: {
    getFormmatedData(date) {
      return moment(date).format('MM/DD/YYYY')
    },
    async loadData() {
      var x = await this.getDataForMainChart()
      if (!x) {
        this.dataForChart = this.emptyChart
      } else {
        this.dataForChart = x
      }
    },
    async getDataForMainChart() {
      let configForCurrChart = JSON.parse(JSON.stringify(this.config))
      var params = {
        query: {
          id_in: [this.project.id],
        },
        aggregation: 'Daily',
        value_types: ['Accumulative'],
        ts_from: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        ts_to: moment().format('YYYY-MM-DD'),
      }
      let data = await axios.post('/api/analytics/monitorings', params)
      let dataForMainChart = data.data

      let { labels, formmatedLabels } = this.getLabels([
        params.ts_from,
        params.ts_to,
      ])

      let { dataSetsFromDB } = organizeDatasets(dataForMainChart, labels)
      if (dataSetsFromDB.length === 0) return

      var flattenDatasets = dataSetsFromDB.flat()
      flattenDatasets = flattenDatasets.filter((set) => {
        if (set?.data?.length > 0) {
          return set
        }
      })
      if (flattenDatasets.length === 0) return

      let tempScales = flattenDatasets.map((data) => {
        return {
          group: data.group,
          unit: data.unit,
        }
      })
      var dataForTabels = dataForMainChart.map((data) => {
        return getDataSetForAccumulative(data, labels)
      })
      dataForTabels = dataForTabels.filter((obj) => {
        if (obj.data.length !== 0) return obj
      })
      tempScales = removeDuplicatesScales(tempScales)
      var currentScales = createScaleObject(tempScales)
      configForCurrChart.scales = currentScales
      return {
        data: {
          labels: formmatedLabels,
          datasets: flattenDatasets,
        },
        config: configForCurrChart,
        tabelsData: dataForTabels,
        aggregation: params.aggregation,
      }
    },
    getDataSetForAccumulative(obj) {
      var x
      if (obj.value_type === 'Instantainus') {
        var x = this.organizeDataForInstantainus(obj.data)
      }
      return {
        backgroundColor: obj.color || this.getRandomColor(),
        borderColor: obj.color || this.getRandomColor(),
        pointBackgroundColor: obj.color || this.getRandomColor(),
        data: x === undefined ? obj.data.map((obj) => obj.value) : x,
        label: obj.name,
        lineTension: 0.5,
        type: obj.chart_type.toLowerCase(),
        yAxisID: obj.group_name + ' ' + obj.unit,
        unit: obj.unit,
        group: obj.group_name,
        value_type: obj.value_type,
      }
    },
    getDataSetsForInstantainus(obj) {
      let minAvgData = obj.data.map((obj) => obj.min_value)
      let maxAvgData = obj.data.map((obj) => obj.max_value)
      let avgData = obj.data.map((obj) => obj.avg_value)
      return [
        {
          backgroundColor: this.getRandomColor(),
          borderColor: this.getRandomColor(),
          pointBackgroundColor: this.getRandomColor(),
          data: minAvgData,
          label: `min. ${obj.name}`,
          lineTension: 0.5,
          type: obj.chart_type.toLowerCase(),
          yAxisID: obj.group_name + ' ' + obj.unit,
          unit: obj.unit,
          group: obj.group_name,
          value_type: obj.value_type,
        },
        {
          backgroundColor: this.getRandomColor(),
          borderColor: this.getRandomColor(),
          pointBackgroundColor: this.getRandomColor(),
          data: maxAvgData,
          label: `max. ${obj.name}`,
          lineTension: 0.5,
          type: obj.chart_type.toLowerCase(),
          yAxisID: obj.group_name + ' ' + obj.unit,
          unit: obj.unit,
          group: obj.group_name,
          value_type: obj.value_type,
        },
        {
          backgroundColor: this.getRandomColor(),
          borderColor: this.getRandomColor(),
          pointBackgroundColor: this.getRandomColor(),
          data: avgData,
          label: `avg. ${obj.name}`,
          lineTension: 0.5,
          type: obj.chart_type.toLowerCase(),
          yAxisID: obj.group_name + ' ' + obj.unit,
          unit: obj.unit,
          group: obj.group_name,
          value_type: obj.value_type,
        },
      ]
    },
    organizeDataForInstantainus(arr) {
      if (arr.length === 0) return
      let minAvgData = arr.map((obj) => obj.min_value)
      let maxAvgData = arr.map((obj) => obj.max_value)
      let avgData = arr.map((obj) => obj.avg_value)
      return {
        minArr: minAvgData,
        maxArr: maxAvgData,
        avgData: avgData,
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      const day = date.getDate()
      const month = date.toLocaleString('default', { month: 'short' })
      return `${day}. ${month}`
    },
    removeDuplicatesScales(arr) {
      let uniqueArray = []
      arr.forEach(function (item) {
        let isUnique = true
        uniqueArray.forEach(function (uniqueItem) {
          if (
            uniqueItem.group === item.group &&
            uniqueItem.unit === item.unit
          ) {
            isUnique = false
          }
        })
        if (isUnique) {
          uniqueArray.push(item)
        }
      })
      return uniqueArray
    },
    createObject(arr) {
      let output = {}
      arr.forEach(function (item, idx) {
        let key = item.group + ' ' + item.unit
        output[key] = {
          type: 'linear',
          position: idx % 2 === 0 ? 'left' : 'right',
          ticks: {
            beginAtZero: true,
            callback: function (value, index, ticks) {
              return (
                value.toLocaleString('en-US') + ' ' + item.unit.toUpperCase()
              )
            },
          },
          title: {
            display: true,
            text: item.group,
          },
          grid: { display: idx === 0 ? true : false },
        }
      })
      output['x'] = {
        ticks: { beginAtZero: true },
        grid: {
          display: false,
          drawBorder: false,
        },
      }
      return output
    },
    getRandomColor() {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    getLabels(date) {
      let labels = getDatesBetween(date)
      let formmatedLabels = labels.map((label) =>
        moment(label).format('YYYY-MM-DD')
      )
      formmatedLabels = labels.map((label) => this.formatDate(label))
      return {
        labels,
        formmatedLabels,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
html {
  overflow: auto;
}
.header-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.main-header-grid {
  display: grid;
  grid-template-columns: 20% repeat(auto-fit, minmax(80px, 1fr));
  gap: 4px;
  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;

    .project-title {
      grid-column: 1 / 3;
    }

    .item {
      grid-column: span 1;
    }
  }

  .project-title {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    font-size: 24px;
    // width: 20%;
    @media (max-width: 900px) {
      width: unset;
    }
  }

  .item {
    display: flex;
    gap: 0.5rem;
    padding-right: 10px;
    place-content: center;
    .img-wrapper {
      display: flex;
      align-items: center;
      img {
        // width: 30px;
        width: 20px;
      }
    }

    .text-wrapper {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      justify-content: center;

      .popup-link {
        background: transparent;
        border-color: transparent;
        padding: 0;
        border: 0;
        color: #337ab7;
        text-decoration: none;
        cursor: pointer;
      }
      .title {
        font-weight: bold;
      }
    }
  }
  .item:not(:last-child) {
    border-right: 1.9px dashed #707070;
  }
}
// .main-header-grid {
//   display: flex;
//   align-items: center;
//   overflow-x: hidden;
//   gap: 12px;
//   @media (max-width: 700px) {
//     flex-direction: column;
//     align-items: unset;
//   }
// }

// .project-title {
//   flex: 0 0 20%;
//   white-space: normal;
//   word-break: break-word;
//   font-weight: bold;
//   display: flex;
//   align-items: center;
//   padding: 0;
//   font-size: 24px;
//   // justify-content: center;
//   white-space: nowrap;
//   padding-bottom: 5px;
// }

// .items-container {
//   display: flex;
//   flex-wrap: nowrap;
//   gap: 10px;
//   padding: 10px 0px 5px 10px;
//   overflow-x: auto;
//   &::-webkit-scrollbar {
//     height: 8px;
//     background-color: #091e4214;
//   }
//   &::-webkit-scrollbar-thumb {
//     background: #5b5b5b;
//   }
//   &::-webkit-scrollbar-track {
//     background: #091e4214;
//     border-radius: 10px;
//   }

//   @media (max-width: 700px) {
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     gap: 16px;
//   }
// }

// .item {
//   display: flex;
//   gap: 0.5rem;
//   padding-right: 10px;
//   border-right: 2px dashed #5b5b5b;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   min-width: fit-content;
//   // min-width: 120px;
//   .img-wrapper {
//     display: flex;
//     align-items: center;
//     img {
//       // width: 30px;
//       width: 20px;
//     }
//   }

//   .text-wrapper {
//     display: flex;
//     flex-direction: column;
//     font-size: 16px;
//     justify-content: center;

//     .popup-link {
//       background: transparent;
//       border-color: transparent;
//       padding: 0;
//       border: 0;
//       color: #337ab7;
//       text-decoration: none;
//       cursor: pointer;
//     }
//     .title {
//       font-weight: bold;
//     }
//   }
// }

.popup-open {
  width: 100%;
  height: 100%;
  z-index: 90;
  background-color: #000000a3;
  left: 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
}
</style>
